module.exports = __webpack_public_path__ + "static/media/flecha_arriba.ec166319.gif";